import React, { useState } from "react";
import CoordinateInputTool from "./CoordinateInputTool";
import './CoordinateInputTool.css';
import { useLanguage } from "./i18n";

export default function CoordinateInputPopup({ onAdd }) {
  const [open, setOpen] = useState(false);
  const { t } = useLanguage();

  return (
    <>
      {/* Fyrkantig ikon-knapp, 34x34px, vit bakgrund, svart text "XYZ" */}
      <div
        style={{
          position: "absolute",
          top: 85, // Justera vid behov för placering ovanför Leaflet tools
          right: 10,
          zIndex: 1200,
        }}
      >
        <button
          title={t("tooltip_openCoordInput")}
          className="coordinate-input-popup-btn"
          onClick={() => setOpen(true)}
          style={{
            background: "#fff",
            border: "1px solid #1976d2",
            borderRadius: "1px",
            width: 32,
            height: 32,
            boxShadow: "0 2px 8px #0002",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            cursor: "pointer",
            fontSize: 16,
            padding: 0,
            transition: "background 0.15s, border-color 0.15s"
          }}
        >
          {/* Enkel svart text "XYZ" centrerad */}
          <span style={{
            color: "#111",
            fontWeight: "bold",
            fontFamily: "monospace",
            fontSize: 15,
            letterSpacing: 1,
            userSelect: "none"
          }}>
            XYZ
          </span>
        </button>
      </div>

      {/* Popup-overlay */}
      {open && (
        <div
          className="coordinate-input-popup-overlay"
          style={{
            position: "fixed",
            zIndex: 3000,
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(0,0,0,0.3)",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
          onClick={() => setOpen(false)}
        >
          <div
            className="coordinate-input-popup-content"
            style={{
              background: "#fff",
              borderRadius: 10,
              boxShadow: "0 8px 32px #0003",
              padding: 0,
              minWidth: 350,
              maxWidth: "98vw",
              maxHeight: "96vh",
              position: "relative",
              overflowY: "auto"
            }}
            onClick={e => e.stopPropagation()}
          >
            {/* Stäng-knapp */}
            <button
              className="coordinate-input-popup-close"
              style={{
                position: "absolute",
                top: 8, right: 8,
                background: "transparent",
                border: "none",
                color: "#1976d2",
                fontSize: 28,
                fontWeight: "bold",
                cursor: "pointer",
                zIndex: 1
              }}
              onClick={() => setOpen(false)}
              title={t("close")}
            >
              ×
            </button>
            <div style={{ padding: "24px 20px 16px 20px" }}>
              <h2 style={{marginTop:0, marginBottom: 18, fontSize: 19, color: "#1976d2"}}>{t("coordinateInput_title")}</h2>
              <CoordinateInputTool
                onAdd={(...args) => {
                  setOpen(false);
                  onAdd && onAdd(...args);
                }}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
}